import { MISSING_TEXT_PLACEHOLDER } from './constants.js'

/**
 * Will format a number to a currency string
 * @param price {number | string} - The number to format
 * @returns {string}
 */
export function formatPrice(price) {
  if (+price === 0) {
    return '$3.00'
  }

  if (!price || isNaN(+price)) {
    return MISSING_TEXT_PLACEHOLDER
  }

  return `$${price}`
}

/**
 * Will replace encoded ampersand with a regular ampersand
 * @param string {string}
 * @returns {string}
 */
export const replaceEncodedAmpersand = (string) => {
  if (!string || typeof string !== 'string') {
    return MISSING_TEXT_PLACEHOLDER
  }

  return string.replace(/&amp;/g, '&')
}

/**
 * Currently, the color map is as such:
 * [blue];[green/blue];[light blue/multi];[blue/multi];[blue/green];[blue stone];[blue/avocado];[bluestone];[sky blue];[blueridge];[dark blue];[light blue]
 * To make a request, we'd like it to be:
 * blue|green/blue|light blue/multi|blue/multi|blue/green|blue stone|blue/avocado|bluestone|sky blue|blueridge|dark blue|light blue
 * This function should be used when the color map is passed to the new search endpoint, as per this comment:
 * https://app.clickup.com/t/8692p3jc1?comment=90120003644906
 * @param value {string}
 * @returns {string}
 */
export function parseWooCommerceStyleSearchParameters(value) {
  return value.replace(/;/g, '|').replace(/\[/g, '').replace(/\]/g, '')
}

/**
 * This function will convert WooCommerce request parameters to the new improved custom API request parameters
 * @param params {Array}
 * @returns {Array}
 */
export function convertWooCommerceRequestParametersToImprovedCustomAPI(params) {
  return params?.map((parameter) => {
    switch (parameter.name) {
      case 'search_colors': {
        return {
          name: 'color',
          value: parseWooCommerceStyleSearchParameters(parameter.value),
        }
      }
      case 'search_brand': {
        return {
          name: 'brand',
          value: parseWooCommerceStyleSearchParameters(parameter.value),
        }
      }
      case 'search_material': {
        return {
          name: 'material',
          value: parseWooCommerceStyleSearchParameters(parameter.value),
        }
      }
      case 'search_use': {
        return {
          name: 'use',
          value: parseWooCommerceStyleSearchParameters(parameter.value),
        }
      }
      case 'search_pattern': {
        return {
          name: 'pattern',
          value: parseWooCommerceStyleSearchParameters(parameter.value),
        }
      }
      default: {
        return parameter
      }
    }
  })
}
